var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "modal-dialog modal-dialog-centered modal-lg mix-campaign-modal"
    },
    [
      _c("div", { staticClass: "mix-campaign-inner" }, [
        _c("div", { staticClass: "mix-campaign-header" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _c("div", { staticClass: "col-md-12" }, [
              _vm.$store.state.brandCreditsRemaining > 0 &&
              !_vm.loadingCredits &&
              _vm.OnBoarded == 1 &&
              _vm.geoPicklFeature &&
              _vm.step <= 4
                ? _c("div", { staticClass: "create-progress mix-progress" }, [
                    _c("div", { staticClass: "progress-line" }, [
                      _c("hr", {
                        staticClass: "done",
                        style: { width: (_vm.step - 1) * 25 + "%" }
                      }),
                      _c("hr", { style: { width: (4 - _vm.step) * 25 + "%" } })
                    ]),
                    _c("div", { staticClass: "mix-steps" }, [
                      _c("div", { staticClass: "step-part" }, [
                        _c(
                          "span",
                          {
                            staticClass: "step-circle",
                            class: { active: _vm.step == 1, done: _vm.step > 1 }
                          },
                          [
                            _vm._v("\n                  1\n                  "),
                            _c("span", { staticClass: "step-label" }, [
                              _vm._v("Workflow Info")
                            ])
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "step-part" }, [
                        _c(
                          "span",
                          {
                            staticClass: "step-circle",
                            class: { active: _vm.step == 2, done: _vm.step > 2 }
                          },
                          [
                            _vm._v("\n                  2\n                  "),
                            _c("span", { staticClass: "step-label" }, [
                              _vm._v("Activities")
                            ])
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "step-part" }, [
                        _c(
                          "span",
                          {
                            staticClass: "step-circle",
                            class: { active: _vm.step == 3, done: _vm.step > 3 }
                          },
                          [
                            _vm._v("\n                  3\n                  "),
                            _c("span", { staticClass: "step-label" }, [
                              _vm._v("Sort Order")
                            ])
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "step-part" }, [
                        _c(
                          "span",
                          {
                            staticClass: "step-circle",
                            class: { active: _vm.step == 4 }
                          },
                          [
                            _vm._v("\n                  4\n                  "),
                            _c("span", { staticClass: "step-label" }, [
                              _vm._v("Location")
                            ])
                          ]
                        )
                      ])
                    ]),
                    _c("p", { staticClass: "mix-step-indicator" }, [
                      _vm._v("Step " + _vm._s(_vm.step) + " of 4")
                    ])
                  ])
                : _vm._e()
            ])
          ]),
          _c("button", {
            ref: "closeCreatePicklPopupButton",
            staticClass: "close",
            attrs: {
              type: "button",
              "data-dismiss": "modal",
              "aria-label": "Close"
            }
          })
        ]),
        _vm.$store.state.brandCreditsRemaining > 0 &&
        !_vm.loadingCredits &&
        _vm.OnBoarded == 1 &&
        _vm.geoPicklFeature
          ? _c(
              "div",
              { staticClass: "modal-body mix-campaign-body" },
              [
                _vm.step == 1
                  ? _c(
                      "form",
                      {
                        staticClass: "mix-step-form",
                        attrs: { "data-vv-scope": "mix-campaign-form" },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.step1($event)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "mix-step-section" }, [
                          _c("h3", { staticClass: "mix-section-title" }, [
                            _vm._v("Workflow details")
                          ]),
                          _c("p", { staticClass: "mix-section-hint" }, [
                            _vm._v(
                              "Name your campaign and optionally add a private unlock code."
                            )
                          ]),
                          _c("div", { staticClass: "row mt15" }, [
                            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "mix-label",
                                  attrs: { for: "mix-campaign-name" }
                                },
                                [_vm._v("Workflow Name")]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.pickl.campaignName,
                                    expression: "pickl.campaignName"
                                  }
                                ],
                                staticClass: "input mix-input",
                                attrs: {
                                  id: "mix-campaign-name",
                                  placeholder: "e.g. Summer Product Launch",
                                  type: "text"
                                },
                                domProps: { value: _vm.pickl.campaignName },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.pickl,
                                      "campaignName",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                              _vm._m(1),
                              _vm.localPicklFeature
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.pickl.unlockCode,
                                        expression: "pickl.unlockCode"
                                      }
                                    ],
                                    staticClass: "input mix-input",
                                    attrs: {
                                      id: "mix-unlock-code",
                                      type: "text",
                                      maxlength: "6",
                                      placeholder: "6 characters max"
                                    },
                                    domProps: { value: _vm.pickl.unlockCode },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.pickl,
                                            "unlockCode",
                                            $event.target.value
                                          )
                                        },
                                        function($event) {
                                          _vm.pickl.unlockCode = $event.target.value.toUpperCase()
                                        }
                                      ]
                                    }
                                  })
                                : _c("p", { staticClass: "mix-contact-note" }, [
                                    _vm._v(
                                      "Contact us to use codes for consumer communities"
                                    )
                                  ])
                            ])
                          ])
                        ]),
                        _c("div", { staticClass: "mix-step-section" }, [
                          _c("h3", { staticClass: "mix-section-title" }, [
                            _vm._v("Launch & notes")
                          ]),
                          _c("div", { staticClass: "row mt15" }, [
                            _c(
                              "div",
                              {
                                staticClass: "col-xs-12 col-sm-6",
                                staticStyle: { padding: "0" }
                              },
                              [
                                _vm._m(2),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-6 col-sm-6" },
                                  [
                                    _c("date-picker", {
                                      attrs: {
                                        disabled: _vm.pickl.immediate_start,
                                        "input-name": "start_date_time",
                                        lang: "en",
                                        type: "date",
                                        editable: false,
                                        format: "MM-DD-YYYY",
                                        "input-class": "input",
                                        width: "100%"
                                      },
                                      model: {
                                        value: _vm.date,
                                        callback: function($$v) {
                                          _vm.date = $$v
                                        },
                                        expression: "date"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-6 col-sm-6" },
                                  [
                                    _c("date-picker", {
                                      staticClass: "timepicker",
                                      attrs: {
                                        disabled: _vm.pickl.immediate_start,
                                        "input-name": "start_date_time",
                                        lang: "en",
                                        type: "time",
                                        editable: false,
                                        format: "h a",
                                        "minute-step": 30,
                                        "time-picker-options": {
                                          start: "00:00",
                                          step: "01:00",
                                          end: "23:00"
                                        },
                                        "input-class": "input",
                                        width: "100%",
                                        placeholder: "Select Time"
                                      },
                                      model: {
                                        value: _vm.time,
                                        callback: function($$v) {
                                          _vm.time = $$v
                                        },
                                        expression: "time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "block",
                                      margin: "auto",
                                      "margin-left": "20px"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.pickl.immediate_start,
                                          expression: "pickl.immediate_start"
                                        }
                                      ],
                                      staticStyle: { "margin-bottom": "4px" },
                                      attrs: {
                                        type: "checkbox",
                                        id: "immediate"
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.pickl.immediate_start
                                        )
                                          ? _vm._i(
                                              _vm.pickl.immediate_start,
                                              null
                                            ) > -1
                                          : _vm.pickl.immediate_start
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.pickl.immediate_start,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.pickl,
                                                  "immediate_start",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.pickl,
                                                  "immediate_start",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.pickl,
                                              "immediate_start",
                                              $$c
                                            )
                                          }
                                        }
                                      }
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticStyle: {
                                          color: "#808080",
                                          "vertical-align": "middle"
                                        },
                                        attrs: { for: "immediate" }
                                      },
                                      [_vm._v("Launch Now")]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "col-xs-12 col-sm-6",
                                staticStyle: { padding: "0" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-12" },
                                  [
                                    _c("span", { staticClass: "mix-label" }, [
                                      _vm._v("Notes for users")
                                    ]),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.pickl.description,
                                          expression: "pickl.description"
                                        }
                                      ],
                                      staticClass:
                                        "input textarea mix-input mix-textarea",
                                      staticStyle: { "min-height": "50px" },
                                      attrs: {
                                        maxlength: "60",
                                        placeholder: "60 characters max",
                                        rows: "3"
                                      },
                                      domProps: {
                                        value: _vm.pickl.description
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.pickl,
                                            "description",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "mix-step-section" }, [
                          _c("h3", { staticClass: "mix-section-title" }, [
                            _vm._v("Extensions & location")
                          ]),
                          _c("p", { staticClass: "mix-section-hint" }, [
                            _vm._v(
                              "Optional auto-extend and whether the campaign is location-restricted."
                            )
                          ]),
                          _c("div", { staticClass: "row mt15" }, [
                            _c(
                              "div",
                              {
                                staticClass: "col-xs-12 col-sm-6",
                                staticStyle: { padding: "0" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-12" },
                                  [
                                    _c("span", { staticClass: "mix-label" }, [
                                      _vm._v("Auto extend tasks")
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "block",
                                          margin: "auto",
                                          "margin-bottom": "10px"
                                        }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.pickl.autoExtend,
                                              expression: "pickl.autoExtend"
                                            }
                                          ],
                                          staticStyle: {
                                            "margin-bottom": "4px"
                                          },
                                          attrs: {
                                            type: "checkbox",
                                            id: "autoextend"
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.pickl.autoExtend
                                            )
                                              ? _vm._i(
                                                  _vm.pickl.autoExtend,
                                                  null
                                                ) > -1
                                              : _vm.pickl.autoExtend
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.pickl.autoExtend,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.pickl,
                                                      "autoExtend",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.pickl,
                                                      "autoExtend",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.pickl,
                                                  "autoExtend",
                                                  $$c
                                                )
                                              }
                                            }
                                          }
                                        }),
                                        _c(
                                          "label",
                                          {
                                            staticStyle: {
                                              color: "#808080",
                                              "vertical-align": "middle"
                                            },
                                            attrs: { for: "autoextend" }
                                          },
                                          [_vm._v("Activate")]
                                        ),
                                        _c("br")
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-6 col-sm-6" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.pickl.extendCounter,
                                            expression: "pickl.extendCounter"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "min:1",
                                            expression: "'min:1'"
                                          }
                                        ],
                                        class: {
                                          input: true,
                                          "is-danger": _vm.errors.has(
                                            "mix-campaign-form.extend_counter"
                                          )
                                        },
                                        attrs: {
                                          disabled: !_vm.pickl.autoExtend,
                                          name: "extend_counter"
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.pickl,
                                              "extendCounter",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          { domProps: { value: 0 } },
                                          [_vm._v("# Extensions")]
                                        ),
                                        _vm._l(_vm.maxExtendCounter, function(
                                          counter
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              key: counter,
                                              domProps: { value: counter }
                                            },
                                            [_vm._v(_vm._s(counter))]
                                          )
                                        })
                                      ],
                                      2
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "mix-field-hint" },
                                      [
                                        _vm._v(
                                          "Tasks expire after " +
                                            _vm._s(
                                              Math.round(
                                                _vm.$store.state.settings
                                                  .pickl_expiration_time / 24
                                              )
                                            ) +
                                            " days"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-6 col-sm-6" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.pickl.extendDays,
                                            expression: "pickl.extendDays"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "min:1",
                                            expression: "'min:1'"
                                          }
                                        ],
                                        class: {
                                          input: true,
                                          "is-danger": _vm.errors.has(
                                            "mix-campaign-form.extend_days"
                                          )
                                        },
                                        attrs: {
                                          disabled: !_vm.pickl.autoExtend,
                                          name: "extend_days"
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.pickl,
                                              "extendDays",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { disabled: "" },
                                            domProps: { value: 0 }
                                          },
                                          [_vm._v("# Days")]
                                        ),
                                        _vm._l(_vm.maxExtendDays, function(
                                          counter
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              key: counter,
                                              domProps: { value: counter }
                                            },
                                            [_vm._v(_vm._s(counter))]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "col-xs-12 col-sm-6",
                                staticStyle: { padding: "0" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-xs-12 col-sm-12",
                                    staticStyle: { "margin-top": "40px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "mix-checkbox-row" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.geoRestricted,
                                              expression: "geoRestricted"
                                            }
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            id: "georestricted"
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.geoRestricted
                                            )
                                              ? _vm._i(
                                                  _vm.geoRestricted,
                                                  null
                                                ) > -1
                                              : _vm.geoRestricted
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.geoRestricted,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.geoRestricted = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.geoRestricted = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.geoRestricted = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _c(
                                          "label",
                                          { attrs: { for: "georestricted" } },
                                          [
                                            _vm._v(
                                              "Restrict to specific store locations"
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "mix-field-hint" },
                                      [
                                        _vm._v(
                                          "If checked, users must be at the selected address. If unchecked, the campaign can be completed from anywhere."
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._m(3)
                      ]
                    )
                  : _vm._e(),
                _vm.step == 1 && _vm.showProductForm
                  ? _c(
                      "form",
                      {
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.addProduct($event)
                          }
                        }
                      },
                      [
                        _c("h2", { staticClass: "sub-heading" }, [
                          _vm._v("What Product?")
                        ]),
                        _c("ProductForm", {
                          ref: "productForm",
                          attrs: { brandId: _vm.brandId },
                          on: {
                            added: _vm.refreshProductList,
                            failed: function($event) {
                              _vm.busy = false
                            }
                          }
                        }),
                        _c("div", { staticClass: "product-buttons" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn-positive",
                              attrs: { type: "<selectbutton" },
                              on: {
                                click: function($event) {
                                  _vm.showProductForm = false
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: { src: "/img/Create Pickl/back.png" }
                              }),
                              _vm._v(" BACK\n          ")
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn-lg-green w50 fRight m0",
                              attrs: { type: "submit", disabled: _vm.busy }
                            },
                            [
                              _vm._v("ADD\n            "),
                              _c("span", { staticClass: "hidden-xs" }, [
                                _vm._v("PRODUCT")
                              ])
                            ]
                          ),
                          _c("div", { staticClass: "clearfix" })
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.step == 2
                  ? _c(
                      "form",
                      {
                        staticClass: "mix-step-form",
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.step2($event)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "mix-step-intro" }, [
                          _c("h2", { staticClass: "mix-step-heading" }, [
                            _vm._v("Select activity types")
                          ]),
                          _c("p", { staticClass: "mix-step-desc" }, [
                            _vm._v(
                              "Add up to " +
                                _vm._s(_vm.maxActivities) +
                                " activities. Configure each one below, then continue to set the order."
                            )
                          ])
                        ]),
                        _vm.activityTypes.length > 0
                          ? _c(
                              "div",
                              { staticClass: "mt15" },
                              _vm._l(_vm.activityTypes, function(
                                activity,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass:
                                      "activity-type-item mix-activity-card"
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-xs-12" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "activity-header",
                                            class: {
                                              collapsed: activity.collapsed
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.toggleActivityCollapse(
                                                  index
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "chevron-icon",
                                              class: activity.collapsed
                                                ? "glyphicon glyphicon-chevron-right"
                                                : "glyphicon glyphicon-chevron-down"
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "activity-title" },
                                              [
                                                _vm._v(
                                                  "Activity " +
                                                    _vm._s(index + 1) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.getActivityTypeLabel(
                                                        activity.type
                                                      )
                                                    )
                                                )
                                              ]
                                            ),
                                            _vm.isActivityValid(activity)
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "complete-badge"
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "glyphicon glyphicon-ok"
                                                    }),
                                                    _vm._v(
                                                      " Complete\n                  "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-negative pull-right remove-btn",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.removeActivityType(
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Remove\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !activity.collapsed,
                                            expression: "!activity.collapsed"
                                          }
                                        ],
                                        staticClass: "activity-content"
                                      },
                                      [
                                        activity.type === "product"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                { staticClass: "in-padd" },
                                                [
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "nav nav-tabs",
                                                      attrs: { role: "tablist" }
                                                    },
                                                    [
                                                      _vm._l(
                                                        activity.config
                                                          .products,
                                                        function(
                                                          picklProduct,
                                                          pIndex
                                                        ) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              key: pIndex,
                                                              class:
                                                                pIndex == 0
                                                                  ? "active"
                                                                  : "",
                                                              attrs: {
                                                                role:
                                                                  "presentation"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href:
                                                                      "#product-" +
                                                                      index +
                                                                      "-" +
                                                                      pIndex,
                                                                    "aria-controls":
                                                                      "product-" +
                                                                      index +
                                                                      "-" +
                                                                      pIndex,
                                                                    role: "tab",
                                                                    "data-toggle":
                                                                      "tab"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      Product " +
                                                                      _vm._s(
                                                                        pIndex +
                                                                          1
                                                                      ) +
                                                                      "\n                    "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      activity.config.products
                                                        .length <
                                                      ((_vm.$store.state
                                                        .settings &&
                                                        _vm.$store.state
                                                          .settings
                                                          .pickl_max_products) ||
                                                        5)
                                                        ? _c(
                                                            "li",
                                                            {
                                                              attrs: {
                                                                role:
                                                                  "presentation"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href:
                                                                      "#add-product"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.addProductToActivityType(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      + Product\n                    "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "tab-content"
                                                    },
                                                    _vm._l(
                                                      activity.config.products,
                                                      function(
                                                        picklProduct,
                                                        pIndex
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: pIndex,
                                                            staticClass:
                                                              "tab-pane fade in",
                                                            class:
                                                              pIndex == 0
                                                                ? "active"
                                                                : "",
                                                            attrs: {
                                                              role: "tabpanel",
                                                              id:
                                                                "product-" +
                                                                index +
                                                                "-" +
                                                                pIndex
                                                            }
                                                          },
                                                          [
                                                            _c("br"),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "row",
                                                                staticStyle: {
                                                                  "margin-right":
                                                                    "1%"
                                                                }
                                                              },
                                                              [
                                                                pIndex > 0
                                                                  ? _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "pull-right",
                                                                        staticStyle: {
                                                                          color:
                                                                            "red"
                                                                        },
                                                                        attrs: {
                                                                          href:
                                                                            "javascript:;"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.removeProductFromActivityType(
                                                                              index,
                                                                              pIndex
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Remove Product"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            ),
                                                            _c(
                                                              "h4",
                                                              {
                                                                staticStyle: {
                                                                  "text-align":
                                                                    "left",
                                                                  color:
                                                                    "#782b54"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Select Product " +
                                                                    _vm._s(
                                                                      pIndex + 1
                                                                    ) +
                                                                    " Tasks"
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-sm-6"
                                                              },
                                                              [
                                                                _c(
                                                                  "select",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          picklProduct.product_id,
                                                                        expression:
                                                                          "picklProduct.product_id"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "input",
                                                                    on: {
                                                                      change: [
                                                                        function(
                                                                          $event
                                                                        ) {
                                                                          var $$selectedVal = Array.prototype.filter
                                                                            .call(
                                                                              $event
                                                                                .target
                                                                                .options,
                                                                              function(
                                                                                o
                                                                              ) {
                                                                                return o.selected
                                                                              }
                                                                            )
                                                                            .map(
                                                                              function(
                                                                                o
                                                                              ) {
                                                                                var val =
                                                                                  "_value" in
                                                                                  o
                                                                                    ? o._value
                                                                                    : o.value
                                                                                return val
                                                                              }
                                                                            )
                                                                          _vm.$set(
                                                                            picklProduct,
                                                                            "product_id",
                                                                            $event
                                                                              .target
                                                                              .multiple
                                                                              ? $$selectedVal
                                                                              : $$selectedVal[0]
                                                                          )
                                                                        },
                                                                        function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.setProductImageForActivityType(
                                                                            index,
                                                                            pIndex,
                                                                            picklProduct.product_id
                                                                          )
                                                                        }
                                                                      ]
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "option",
                                                                      {
                                                                        attrs: {
                                                                          value:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Select Product"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._l(
                                                                      _vm.products,
                                                                      function(
                                                                        product
                                                                      ) {
                                                                        return _c(
                                                                          "option",
                                                                          {
                                                                            key:
                                                                              product.id,
                                                                            domProps: {
                                                                              value:
                                                                                product.id
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                product.name
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    )
                                                                  ],
                                                                  2
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-sm-6"
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        picklProduct.description,
                                                                      expression:
                                                                        "picklProduct.description"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "input",
                                                                  attrs: {
                                                                    placeholder:
                                                                      "Description Max 40 Characters"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      picklProduct.description
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        picklProduct,
                                                                        "description",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              ]
                                                            ),
                                                            _c(
                                                              "VuePerfectScrollbar",
                                                              {
                                                                staticClass:
                                                                  "attr-imgs"
                                                              },
                                                              [
                                                                _c(
                                                                  "ul",
                                                                  {
                                                                    staticClass:
                                                                      "nav nav-tabs",
                                                                    attrs: {
                                                                      role:
                                                                        "tablist"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "active",
                                                                        attrs: {
                                                                          role:
                                                                            "presentation"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            attrs: {
                                                                              href:
                                                                                "#events-" +
                                                                                index +
                                                                                "-" +
                                                                                pIndex,
                                                                              "aria-controls":
                                                                                "events",
                                                                              role:
                                                                                "tab",
                                                                              "data-toggle":
                                                                                "tab"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Events"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "li",
                                                                      {
                                                                        attrs: {
                                                                          role:
                                                                            "presentation"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            attrs: {
                                                                              href:
                                                                                "#dining-" +
                                                                                index +
                                                                                "-" +
                                                                                pIndex,
                                                                              "aria-controls":
                                                                                "dining",
                                                                              role:
                                                                                "tab",
                                                                              "data-toggle":
                                                                                "tab"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Dining"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "li",
                                                                      {
                                                                        attrs: {
                                                                          role:
                                                                            "presentation"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            attrs: {
                                                                              href:
                                                                                "#entertainment-" +
                                                                                index +
                                                                                "-" +
                                                                                pIndex,
                                                                              "aria-controls":
                                                                                "entertainment",
                                                                              role:
                                                                                "tab",
                                                                              "data-toggle":
                                                                                "tab"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Entertainment"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "li",
                                                                      {
                                                                        attrs: {
                                                                          role:
                                                                            "presentation"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            attrs: {
                                                                              href:
                                                                                "#hospitality-" +
                                                                                index +
                                                                                "-" +
                                                                                pIndex,
                                                                              "aria-controls":
                                                                                "hospitality",
                                                                              role:
                                                                                "tab",
                                                                              "data-toggle":
                                                                                "tab"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Hospitality"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "li",
                                                                      {
                                                                        attrs: {
                                                                          role:
                                                                            "presentation"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            attrs: {
                                                                              href:
                                                                                "#retail-" +
                                                                                index +
                                                                                "-" +
                                                                                pIndex,
                                                                              "aria-controls":
                                                                                "retail",
                                                                              role:
                                                                                "tab",
                                                                              "data-toggle":
                                                                                "tab"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Retail"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "tab-content"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "tab-pane fade in active",
                                                                        attrs: {
                                                                          role:
                                                                            "tabpanel",
                                                                          id:
                                                                            "events-" +
                                                                            index +
                                                                            "-" +
                                                                            pIndex
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        _vm.eventsTasks,
                                                                        function(
                                                                          task
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            {
                                                                              key:
                                                                                task.id,
                                                                              staticClass:
                                                                                "col-xs-3 col-md-2 photo"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  directives: [
                                                                                    {
                                                                                      name:
                                                                                        "model",
                                                                                      rawName:
                                                                                        "v-model",
                                                                                      value:
                                                                                        activity
                                                                                          .config
                                                                                          .products[
                                                                                          pIndex
                                                                                        ]
                                                                                          .task_ids,
                                                                                      expression:
                                                                                        "activity.config.products[pIndex].task_ids"
                                                                                    }
                                                                                  ],
                                                                                  attrs: {
                                                                                    type:
                                                                                      "checkbox",
                                                                                    id:
                                                                                      "attr-" +
                                                                                      index +
                                                                                      "-" +
                                                                                      pIndex +
                                                                                      "-" +
                                                                                      task.id
                                                                                  },
                                                                                  domProps: {
                                                                                    value:
                                                                                      task.id,
                                                                                    checked: Array.isArray(
                                                                                      activity
                                                                                        .config
                                                                                        .products[
                                                                                        pIndex
                                                                                      ]
                                                                                        .task_ids
                                                                                    )
                                                                                      ? _vm._i(
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ]
                                                                                            .task_ids,
                                                                                          task.id
                                                                                        ) >
                                                                                        -1
                                                                                      : activity
                                                                                          .config
                                                                                          .products[
                                                                                          pIndex
                                                                                        ]
                                                                                          .task_ids
                                                                                  },
                                                                                  on: {
                                                                                    change: function(
                                                                                      $event
                                                                                    ) {
                                                                                      var $$a =
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ]
                                                                                            .task_ids,
                                                                                        $$el =
                                                                                          $event.target,
                                                                                        $$c = $$el.checked
                                                                                          ? true
                                                                                          : false
                                                                                      if (
                                                                                        Array.isArray(
                                                                                          $$a
                                                                                        )
                                                                                      ) {
                                                                                        var $$v =
                                                                                            task.id,
                                                                                          $$i = _vm._i(
                                                                                            $$a,
                                                                                            $$v
                                                                                          )
                                                                                        if (
                                                                                          $$el.checked
                                                                                        ) {
                                                                                          $$i <
                                                                                            0 &&
                                                                                            _vm.$set(
                                                                                              activity
                                                                                                .config
                                                                                                .products[
                                                                                                pIndex
                                                                                              ],
                                                                                              "task_ids",
                                                                                              $$a.concat(
                                                                                                [
                                                                                                  $$v
                                                                                                ]
                                                                                              )
                                                                                            )
                                                                                        } else {
                                                                                          $$i >
                                                                                            -1 &&
                                                                                            _vm.$set(
                                                                                              activity
                                                                                                .config
                                                                                                .products[
                                                                                                pIndex
                                                                                              ],
                                                                                              "task_ids",
                                                                                              $$a
                                                                                                .slice(
                                                                                                  0,
                                                                                                  $$i
                                                                                                )
                                                                                                .concat(
                                                                                                  $$a.slice(
                                                                                                    $$i +
                                                                                                      1
                                                                                                  )
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                      } else {
                                                                                        _vm.$set(
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ],
                                                                                          "task_ids",
                                                                                          $$c
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "label",
                                                                                {
                                                                                  staticClass:
                                                                                    "img-contain",
                                                                                  attrs: {
                                                                                    for:
                                                                                      "attr-" +
                                                                                      index +
                                                                                      "-" +
                                                                                      pIndex +
                                                                                      "-" +
                                                                                      task.id
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "img",
                                                                                    {
                                                                                      directives: [
                                                                                        {
                                                                                          name:
                                                                                            "square-img",
                                                                                          rawName:
                                                                                            "v-square-img",
                                                                                          value: {
                                                                                            ratio: 1.5
                                                                                          },
                                                                                          expression:
                                                                                            "{ ratio: 1.5 }"
                                                                                        }
                                                                                      ],
                                                                                      staticClass:
                                                                                        "vertical-center-transform",
                                                                                      attrs: {
                                                                                        src:
                                                                                          task.image +
                                                                                          _vm.lowSrcQuery
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "img-overlay"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "img",
                                                                                        {
                                                                                          staticClass:
                                                                                            "img-tick",
                                                                                          attrs: {
                                                                                            src:
                                                                                              "/img/Create Pickl/selectpickl_icon.png"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "vertical-center-transform task-name"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              task.name
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "tab-pane fade in",
                                                                        attrs: {
                                                                          role:
                                                                            "tabpanel",
                                                                          id:
                                                                            "dining-" +
                                                                            index +
                                                                            "-" +
                                                                            pIndex
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        _vm.diningTasks,
                                                                        function(
                                                                          task
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            {
                                                                              key:
                                                                                task.id,
                                                                              staticClass:
                                                                                "col-xs-3 col-md-2 photo"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  directives: [
                                                                                    {
                                                                                      name:
                                                                                        "model",
                                                                                      rawName:
                                                                                        "v-model",
                                                                                      value:
                                                                                        activity
                                                                                          .config
                                                                                          .products[
                                                                                          pIndex
                                                                                        ]
                                                                                          .task_ids,
                                                                                      expression:
                                                                                        "activity.config.products[pIndex].task_ids"
                                                                                    }
                                                                                  ],
                                                                                  attrs: {
                                                                                    type:
                                                                                      "checkbox",
                                                                                    id:
                                                                                      "attr-" +
                                                                                      index +
                                                                                      "-" +
                                                                                      pIndex +
                                                                                      "-" +
                                                                                      task.id
                                                                                  },
                                                                                  domProps: {
                                                                                    value:
                                                                                      task.id,
                                                                                    checked: Array.isArray(
                                                                                      activity
                                                                                        .config
                                                                                        .products[
                                                                                        pIndex
                                                                                      ]
                                                                                        .task_ids
                                                                                    )
                                                                                      ? _vm._i(
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ]
                                                                                            .task_ids,
                                                                                          task.id
                                                                                        ) >
                                                                                        -1
                                                                                      : activity
                                                                                          .config
                                                                                          .products[
                                                                                          pIndex
                                                                                        ]
                                                                                          .task_ids
                                                                                  },
                                                                                  on: {
                                                                                    change: function(
                                                                                      $event
                                                                                    ) {
                                                                                      var $$a =
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ]
                                                                                            .task_ids,
                                                                                        $$el =
                                                                                          $event.target,
                                                                                        $$c = $$el.checked
                                                                                          ? true
                                                                                          : false
                                                                                      if (
                                                                                        Array.isArray(
                                                                                          $$a
                                                                                        )
                                                                                      ) {
                                                                                        var $$v =
                                                                                            task.id,
                                                                                          $$i = _vm._i(
                                                                                            $$a,
                                                                                            $$v
                                                                                          )
                                                                                        if (
                                                                                          $$el.checked
                                                                                        ) {
                                                                                          $$i <
                                                                                            0 &&
                                                                                            _vm.$set(
                                                                                              activity
                                                                                                .config
                                                                                                .products[
                                                                                                pIndex
                                                                                              ],
                                                                                              "task_ids",
                                                                                              $$a.concat(
                                                                                                [
                                                                                                  $$v
                                                                                                ]
                                                                                              )
                                                                                            )
                                                                                        } else {
                                                                                          $$i >
                                                                                            -1 &&
                                                                                            _vm.$set(
                                                                                              activity
                                                                                                .config
                                                                                                .products[
                                                                                                pIndex
                                                                                              ],
                                                                                              "task_ids",
                                                                                              $$a
                                                                                                .slice(
                                                                                                  0,
                                                                                                  $$i
                                                                                                )
                                                                                                .concat(
                                                                                                  $$a.slice(
                                                                                                    $$i +
                                                                                                      1
                                                                                                  )
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                      } else {
                                                                                        _vm.$set(
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ],
                                                                                          "task_ids",
                                                                                          $$c
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "label",
                                                                                {
                                                                                  staticClass:
                                                                                    "img-contain",
                                                                                  attrs: {
                                                                                    for:
                                                                                      "attr-" +
                                                                                      index +
                                                                                      "-" +
                                                                                      pIndex +
                                                                                      "-" +
                                                                                      task.id
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "img",
                                                                                    {
                                                                                      directives: [
                                                                                        {
                                                                                          name:
                                                                                            "square-img",
                                                                                          rawName:
                                                                                            "v-square-img",
                                                                                          value: {
                                                                                            ratio: 1.5
                                                                                          },
                                                                                          expression:
                                                                                            "{ ratio: 1.5 }"
                                                                                        }
                                                                                      ],
                                                                                      staticClass:
                                                                                        "vertical-center-transform",
                                                                                      attrs: {
                                                                                        src:
                                                                                          task.image +
                                                                                          _vm.lowSrcQuery
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "img-overlay"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "img",
                                                                                        {
                                                                                          staticClass:
                                                                                            "img-tick",
                                                                                          attrs: {
                                                                                            src:
                                                                                              "/img/Create Pickl/selectpickl_icon.png"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "vertical-center-transform task-name"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              task.name
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "tab-pane fade in",
                                                                        attrs: {
                                                                          role:
                                                                            "tabpanel",
                                                                          id:
                                                                            "entertainment-" +
                                                                            index +
                                                                            "-" +
                                                                            pIndex
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        _vm.entertainmentTasks,
                                                                        function(
                                                                          task
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            {
                                                                              key:
                                                                                task.id,
                                                                              staticClass:
                                                                                "col-xs-3 col-md-2 photo"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  directives: [
                                                                                    {
                                                                                      name:
                                                                                        "model",
                                                                                      rawName:
                                                                                        "v-model",
                                                                                      value:
                                                                                        activity
                                                                                          .config
                                                                                          .products[
                                                                                          pIndex
                                                                                        ]
                                                                                          .task_ids,
                                                                                      expression:
                                                                                        "activity.config.products[pIndex].task_ids"
                                                                                    }
                                                                                  ],
                                                                                  attrs: {
                                                                                    type:
                                                                                      "checkbox",
                                                                                    id:
                                                                                      "attr-" +
                                                                                      index +
                                                                                      "-" +
                                                                                      pIndex +
                                                                                      "-" +
                                                                                      task.id
                                                                                  },
                                                                                  domProps: {
                                                                                    value:
                                                                                      task.id,
                                                                                    checked: Array.isArray(
                                                                                      activity
                                                                                        .config
                                                                                        .products[
                                                                                        pIndex
                                                                                      ]
                                                                                        .task_ids
                                                                                    )
                                                                                      ? _vm._i(
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ]
                                                                                            .task_ids,
                                                                                          task.id
                                                                                        ) >
                                                                                        -1
                                                                                      : activity
                                                                                          .config
                                                                                          .products[
                                                                                          pIndex
                                                                                        ]
                                                                                          .task_ids
                                                                                  },
                                                                                  on: {
                                                                                    change: function(
                                                                                      $event
                                                                                    ) {
                                                                                      var $$a =
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ]
                                                                                            .task_ids,
                                                                                        $$el =
                                                                                          $event.target,
                                                                                        $$c = $$el.checked
                                                                                          ? true
                                                                                          : false
                                                                                      if (
                                                                                        Array.isArray(
                                                                                          $$a
                                                                                        )
                                                                                      ) {
                                                                                        var $$v =
                                                                                            task.id,
                                                                                          $$i = _vm._i(
                                                                                            $$a,
                                                                                            $$v
                                                                                          )
                                                                                        if (
                                                                                          $$el.checked
                                                                                        ) {
                                                                                          $$i <
                                                                                            0 &&
                                                                                            _vm.$set(
                                                                                              activity
                                                                                                .config
                                                                                                .products[
                                                                                                pIndex
                                                                                              ],
                                                                                              "task_ids",
                                                                                              $$a.concat(
                                                                                                [
                                                                                                  $$v
                                                                                                ]
                                                                                              )
                                                                                            )
                                                                                        } else {
                                                                                          $$i >
                                                                                            -1 &&
                                                                                            _vm.$set(
                                                                                              activity
                                                                                                .config
                                                                                                .products[
                                                                                                pIndex
                                                                                              ],
                                                                                              "task_ids",
                                                                                              $$a
                                                                                                .slice(
                                                                                                  0,
                                                                                                  $$i
                                                                                                )
                                                                                                .concat(
                                                                                                  $$a.slice(
                                                                                                    $$i +
                                                                                                      1
                                                                                                  )
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                      } else {
                                                                                        _vm.$set(
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ],
                                                                                          "task_ids",
                                                                                          $$c
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "label",
                                                                                {
                                                                                  staticClass:
                                                                                    "img-contain",
                                                                                  attrs: {
                                                                                    for:
                                                                                      "attr-" +
                                                                                      index +
                                                                                      "-" +
                                                                                      pIndex +
                                                                                      "-" +
                                                                                      task.id
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "img",
                                                                                    {
                                                                                      directives: [
                                                                                        {
                                                                                          name:
                                                                                            "square-img",
                                                                                          rawName:
                                                                                            "v-square-img",
                                                                                          value: {
                                                                                            ratio: 1.5
                                                                                          },
                                                                                          expression:
                                                                                            "{ ratio: 1.5 }"
                                                                                        }
                                                                                      ],
                                                                                      staticClass:
                                                                                        "vertical-center-transform",
                                                                                      attrs: {
                                                                                        src:
                                                                                          task.image +
                                                                                          _vm.lowSrcQuery
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "img-overlay"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "img",
                                                                                        {
                                                                                          staticClass:
                                                                                            "img-tick",
                                                                                          attrs: {
                                                                                            src:
                                                                                              "/img/Create Pickl/selectpickl_icon.png"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "vertical-center-transform task-name"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              task.name
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "tab-pane fade in",
                                                                        attrs: {
                                                                          role:
                                                                            "tabpanel",
                                                                          id:
                                                                            "hospitality-" +
                                                                            index +
                                                                            "-" +
                                                                            pIndex
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        _vm.hospitalityTasks,
                                                                        function(
                                                                          task
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            {
                                                                              key:
                                                                                task.id,
                                                                              staticClass:
                                                                                "col-xs-3 col-md-2 photo"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  directives: [
                                                                                    {
                                                                                      name:
                                                                                        "model",
                                                                                      rawName:
                                                                                        "v-model",
                                                                                      value:
                                                                                        activity
                                                                                          .config
                                                                                          .products[
                                                                                          pIndex
                                                                                        ]
                                                                                          .task_ids,
                                                                                      expression:
                                                                                        "activity.config.products[pIndex].task_ids"
                                                                                    }
                                                                                  ],
                                                                                  attrs: {
                                                                                    type:
                                                                                      "checkbox",
                                                                                    id:
                                                                                      "attr-" +
                                                                                      index +
                                                                                      "-" +
                                                                                      pIndex +
                                                                                      "-" +
                                                                                      task.id
                                                                                  },
                                                                                  domProps: {
                                                                                    value:
                                                                                      task.id,
                                                                                    checked: Array.isArray(
                                                                                      activity
                                                                                        .config
                                                                                        .products[
                                                                                        pIndex
                                                                                      ]
                                                                                        .task_ids
                                                                                    )
                                                                                      ? _vm._i(
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ]
                                                                                            .task_ids,
                                                                                          task.id
                                                                                        ) >
                                                                                        -1
                                                                                      : activity
                                                                                          .config
                                                                                          .products[
                                                                                          pIndex
                                                                                        ]
                                                                                          .task_ids
                                                                                  },
                                                                                  on: {
                                                                                    change: function(
                                                                                      $event
                                                                                    ) {
                                                                                      var $$a =
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ]
                                                                                            .task_ids,
                                                                                        $$el =
                                                                                          $event.target,
                                                                                        $$c = $$el.checked
                                                                                          ? true
                                                                                          : false
                                                                                      if (
                                                                                        Array.isArray(
                                                                                          $$a
                                                                                        )
                                                                                      ) {
                                                                                        var $$v =
                                                                                            task.id,
                                                                                          $$i = _vm._i(
                                                                                            $$a,
                                                                                            $$v
                                                                                          )
                                                                                        if (
                                                                                          $$el.checked
                                                                                        ) {
                                                                                          $$i <
                                                                                            0 &&
                                                                                            _vm.$set(
                                                                                              activity
                                                                                                .config
                                                                                                .products[
                                                                                                pIndex
                                                                                              ],
                                                                                              "task_ids",
                                                                                              $$a.concat(
                                                                                                [
                                                                                                  $$v
                                                                                                ]
                                                                                              )
                                                                                            )
                                                                                        } else {
                                                                                          $$i >
                                                                                            -1 &&
                                                                                            _vm.$set(
                                                                                              activity
                                                                                                .config
                                                                                                .products[
                                                                                                pIndex
                                                                                              ],
                                                                                              "task_ids",
                                                                                              $$a
                                                                                                .slice(
                                                                                                  0,
                                                                                                  $$i
                                                                                                )
                                                                                                .concat(
                                                                                                  $$a.slice(
                                                                                                    $$i +
                                                                                                      1
                                                                                                  )
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                      } else {
                                                                                        _vm.$set(
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ],
                                                                                          "task_ids",
                                                                                          $$c
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "label",
                                                                                {
                                                                                  staticClass:
                                                                                    "img-contain",
                                                                                  attrs: {
                                                                                    for:
                                                                                      "attr-" +
                                                                                      index +
                                                                                      "-" +
                                                                                      pIndex +
                                                                                      "-" +
                                                                                      task.id
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "img",
                                                                                    {
                                                                                      directives: [
                                                                                        {
                                                                                          name:
                                                                                            "square-img",
                                                                                          rawName:
                                                                                            "v-square-img",
                                                                                          value: {
                                                                                            ratio: 1.5
                                                                                          },
                                                                                          expression:
                                                                                            "{ ratio: 1.5 }"
                                                                                        }
                                                                                      ],
                                                                                      staticClass:
                                                                                        "vertical-center-transform",
                                                                                      attrs: {
                                                                                        src:
                                                                                          task.image +
                                                                                          _vm.lowSrcQuery
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "img-overlay"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "img",
                                                                                        {
                                                                                          staticClass:
                                                                                            "img-tick",
                                                                                          attrs: {
                                                                                            src:
                                                                                              "/img/Create Pickl/selectpickl_icon.png"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "vertical-center-transform task-name"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              task.name
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "tab-pane fade in",
                                                                        attrs: {
                                                                          role:
                                                                            "tabpanel",
                                                                          id:
                                                                            "retail-" +
                                                                            index +
                                                                            "-" +
                                                                            pIndex
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        _vm.retailTasks,
                                                                        function(
                                                                          task
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            {
                                                                              key:
                                                                                task.id,
                                                                              staticClass:
                                                                                "col-xs-3 col-md-2 photo"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  directives: [
                                                                                    {
                                                                                      name:
                                                                                        "model",
                                                                                      rawName:
                                                                                        "v-model",
                                                                                      value:
                                                                                        activity
                                                                                          .config
                                                                                          .products[
                                                                                          pIndex
                                                                                        ]
                                                                                          .task_ids,
                                                                                      expression:
                                                                                        "activity.config.products[pIndex].task_ids"
                                                                                    }
                                                                                  ],
                                                                                  attrs: {
                                                                                    type:
                                                                                      "checkbox",
                                                                                    id:
                                                                                      "attr-" +
                                                                                      index +
                                                                                      "-" +
                                                                                      pIndex +
                                                                                      "-" +
                                                                                      task.id
                                                                                  },
                                                                                  domProps: {
                                                                                    value:
                                                                                      task.id,
                                                                                    checked: Array.isArray(
                                                                                      activity
                                                                                        .config
                                                                                        .products[
                                                                                        pIndex
                                                                                      ]
                                                                                        .task_ids
                                                                                    )
                                                                                      ? _vm._i(
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ]
                                                                                            .task_ids,
                                                                                          task.id
                                                                                        ) >
                                                                                        -1
                                                                                      : activity
                                                                                          .config
                                                                                          .products[
                                                                                          pIndex
                                                                                        ]
                                                                                          .task_ids
                                                                                  },
                                                                                  on: {
                                                                                    change: function(
                                                                                      $event
                                                                                    ) {
                                                                                      var $$a =
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ]
                                                                                            .task_ids,
                                                                                        $$el =
                                                                                          $event.target,
                                                                                        $$c = $$el.checked
                                                                                          ? true
                                                                                          : false
                                                                                      if (
                                                                                        Array.isArray(
                                                                                          $$a
                                                                                        )
                                                                                      ) {
                                                                                        var $$v =
                                                                                            task.id,
                                                                                          $$i = _vm._i(
                                                                                            $$a,
                                                                                            $$v
                                                                                          )
                                                                                        if (
                                                                                          $$el.checked
                                                                                        ) {
                                                                                          $$i <
                                                                                            0 &&
                                                                                            _vm.$set(
                                                                                              activity
                                                                                                .config
                                                                                                .products[
                                                                                                pIndex
                                                                                              ],
                                                                                              "task_ids",
                                                                                              $$a.concat(
                                                                                                [
                                                                                                  $$v
                                                                                                ]
                                                                                              )
                                                                                            )
                                                                                        } else {
                                                                                          $$i >
                                                                                            -1 &&
                                                                                            _vm.$set(
                                                                                              activity
                                                                                                .config
                                                                                                .products[
                                                                                                pIndex
                                                                                              ],
                                                                                              "task_ids",
                                                                                              $$a
                                                                                                .slice(
                                                                                                  0,
                                                                                                  $$i
                                                                                                )
                                                                                                .concat(
                                                                                                  $$a.slice(
                                                                                                    $$i +
                                                                                                      1
                                                                                                  )
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                      } else {
                                                                                        _vm.$set(
                                                                                          activity
                                                                                            .config
                                                                                            .products[
                                                                                            pIndex
                                                                                          ],
                                                                                          "task_ids",
                                                                                          $$c
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "label",
                                                                                {
                                                                                  staticClass:
                                                                                    "img-contain",
                                                                                  attrs: {
                                                                                    for:
                                                                                      "attr-" +
                                                                                      index +
                                                                                      "-" +
                                                                                      pIndex +
                                                                                      "-" +
                                                                                      task.id
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "img",
                                                                                    {
                                                                                      directives: [
                                                                                        {
                                                                                          name:
                                                                                            "square-img",
                                                                                          rawName:
                                                                                            "v-square-img",
                                                                                          value: {
                                                                                            ratio: 1.5
                                                                                          },
                                                                                          expression:
                                                                                            "{ ratio: 1.5 }"
                                                                                        }
                                                                                      ],
                                                                                      staticClass:
                                                                                        "vertical-center-transform",
                                                                                      attrs: {
                                                                                        src:
                                                                                          task.image +
                                                                                          _vm.lowSrcQuery
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "img-overlay"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "img",
                                                                                        {
                                                                                          staticClass:
                                                                                            "img-tick",
                                                                                          attrs: {
                                                                                            src:
                                                                                              "/img/Create Pickl/selectpickl_icon.png"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "vertical-center-transform task-name"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              task.name
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    )
                                                                  ]
                                                                ),
                                                                _c("div", {
                                                                  staticClass:
                                                                    "clearfix"
                                                                })
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        activity.type === "photo"
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "VuePerfectScrollbar",
                                                  { staticClass: "attr-imgs" },
                                                  [
                                                    _c(
                                                      "ul",
                                                      {
                                                        staticClass:
                                                          "nav nav-tabs",
                                                        attrs: {
                                                          role: "tablist"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "li",
                                                          {
                                                            staticClass:
                                                              "active",
                                                            attrs: {
                                                              role:
                                                                "presentation"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    "#photo-events-" +
                                                                    index,
                                                                  "aria-controls":
                                                                    "events",
                                                                  role: "tab",
                                                                  "data-toggle":
                                                                    "tab"
                                                                }
                                                              },
                                                              [_vm._v("Events")]
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "li",
                                                          {
                                                            attrs: {
                                                              role:
                                                                "presentation"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    "#photo-dining-" +
                                                                    index,
                                                                  "aria-controls":
                                                                    "dining",
                                                                  role: "tab",
                                                                  "data-toggle":
                                                                    "tab"
                                                                }
                                                              },
                                                              [_vm._v("Dining")]
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "li",
                                                          {
                                                            attrs: {
                                                              role:
                                                                "presentation"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    "#photo-entertainment-" +
                                                                    index,
                                                                  "aria-controls":
                                                                    "entertainment",
                                                                  role: "tab",
                                                                  "data-toggle":
                                                                    "tab"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Entertainment"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "li",
                                                          {
                                                            attrs: {
                                                              role:
                                                                "presentation"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    "#photo-hospitality-" +
                                                                    index,
                                                                  "aria-controls":
                                                                    "hospitality",
                                                                  role: "tab",
                                                                  "data-toggle":
                                                                    "tab"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Hospitality"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "li",
                                                          {
                                                            attrs: {
                                                              role:
                                                                "presentation"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    "#photo-retail-" +
                                                                    index,
                                                                  "aria-controls":
                                                                    "retail",
                                                                  role: "tab",
                                                                  "data-toggle":
                                                                    "tab"
                                                                }
                                                              },
                                                              [_vm._v("Retail")]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "tab-content"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tab-pane fade in active",
                                                            attrs: {
                                                              role: "tabpanel",
                                                              id:
                                                                "photo-events-" +
                                                                index
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.eventsTasks,
                                                            function(task) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: task.id,
                                                                  staticClass:
                                                                    "col-xs-3 col-md-2 photo"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          activity
                                                                            .config
                                                                            .task_ids,
                                                                        expression:
                                                                          "activity.config.task_ids"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      type:
                                                                        "checkbox",
                                                                      id:
                                                                        "photo-task-" +
                                                                        index +
                                                                        "-" +
                                                                        task.id
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        task.id,
                                                                      checked: Array.isArray(
                                                                        activity
                                                                          .config
                                                                          .task_ids
                                                                      )
                                                                        ? _vm._i(
                                                                            activity
                                                                              .config
                                                                              .task_ids,
                                                                            task.id
                                                                          ) > -1
                                                                        : activity
                                                                            .config
                                                                            .task_ids
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            activity
                                                                              .config
                                                                              .task_ids,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c = $$el.checked
                                                                            ? true
                                                                            : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              task.id,
                                                                            $$i = _vm._i(
                                                                              $$a,
                                                                              $$v
                                                                            )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                activity.config,
                                                                                "task_ids",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                activity.config,
                                                                                "task_ids",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            activity.config,
                                                                            "task_ids",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  }),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "img-contain",
                                                                      attrs: {
                                                                        for:
                                                                          "photo-task-" +
                                                                          index +
                                                                          "-" +
                                                                          task.id
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "square-img",
                                                                              rawName:
                                                                                "v-square-img",
                                                                              value: {
                                                                                ratio: 1.5
                                                                              },
                                                                              expression:
                                                                                "{ ratio: 1.5 }"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "vertical-center-transform",
                                                                          attrs: {
                                                                            src:
                                                                              task.image +
                                                                              _vm.lowSrcQuery
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "img-overlay"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "img",
                                                                            {
                                                                              staticClass:
                                                                                "img-tick",
                                                                              attrs: {
                                                                                src:
                                                                                  "/img/Create Pickl/selectpickl_icon.png"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "vertical-center-transform task-name"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  task.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tab-pane fade in",
                                                            attrs: {
                                                              role: "tabpanel",
                                                              id:
                                                                "photo-dining-" +
                                                                index
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.diningTasks,
                                                            function(task) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: task.id,
                                                                  staticClass:
                                                                    "col-xs-3 col-md-2 photo"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          activity
                                                                            .config
                                                                            .task_ids,
                                                                        expression:
                                                                          "activity.config.task_ids"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      type:
                                                                        "checkbox",
                                                                      id:
                                                                        "photo-task-" +
                                                                        index +
                                                                        "-" +
                                                                        task.id
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        task.id,
                                                                      checked: Array.isArray(
                                                                        activity
                                                                          .config
                                                                          .task_ids
                                                                      )
                                                                        ? _vm._i(
                                                                            activity
                                                                              .config
                                                                              .task_ids,
                                                                            task.id
                                                                          ) > -1
                                                                        : activity
                                                                            .config
                                                                            .task_ids
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            activity
                                                                              .config
                                                                              .task_ids,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c = $$el.checked
                                                                            ? true
                                                                            : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              task.id,
                                                                            $$i = _vm._i(
                                                                              $$a,
                                                                              $$v
                                                                            )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                activity.config,
                                                                                "task_ids",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                activity.config,
                                                                                "task_ids",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            activity.config,
                                                                            "task_ids",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  }),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "img-contain",
                                                                      attrs: {
                                                                        for:
                                                                          "photo-task-" +
                                                                          index +
                                                                          "-" +
                                                                          task.id
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "square-img",
                                                                              rawName:
                                                                                "v-square-img",
                                                                              value: {
                                                                                ratio: 1.5
                                                                              },
                                                                              expression:
                                                                                "{ ratio: 1.5 }"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "vertical-center-transform",
                                                                          attrs: {
                                                                            src:
                                                                              task.image +
                                                                              _vm.lowSrcQuery
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "img-overlay"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "img",
                                                                            {
                                                                              staticClass:
                                                                                "img-tick",
                                                                              attrs: {
                                                                                src:
                                                                                  "/img/Create Pickl/selectpickl_icon.png"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "vertical-center-transform task-name"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  task.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tab-pane fade in",
                                                            attrs: {
                                                              role: "tabpanel",
                                                              id:
                                                                "photo-entertainment-" +
                                                                index
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.entertainmentTasks,
                                                            function(task) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: task.id,
                                                                  staticClass:
                                                                    "col-xs-3 col-md-2 photo"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          activity
                                                                            .config
                                                                            .task_ids,
                                                                        expression:
                                                                          "activity.config.task_ids"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      type:
                                                                        "checkbox",
                                                                      id:
                                                                        "photo-task-" +
                                                                        index +
                                                                        "-" +
                                                                        task.id
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        task.id,
                                                                      checked: Array.isArray(
                                                                        activity
                                                                          .config
                                                                          .task_ids
                                                                      )
                                                                        ? _vm._i(
                                                                            activity
                                                                              .config
                                                                              .task_ids,
                                                                            task.id
                                                                          ) > -1
                                                                        : activity
                                                                            .config
                                                                            .task_ids
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            activity
                                                                              .config
                                                                              .task_ids,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c = $$el.checked
                                                                            ? true
                                                                            : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              task.id,
                                                                            $$i = _vm._i(
                                                                              $$a,
                                                                              $$v
                                                                            )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                activity.config,
                                                                                "task_ids",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                activity.config,
                                                                                "task_ids",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            activity.config,
                                                                            "task_ids",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  }),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "img-contain",
                                                                      attrs: {
                                                                        for:
                                                                          "photo-task-" +
                                                                          index +
                                                                          "-" +
                                                                          task.id
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "square-img",
                                                                              rawName:
                                                                                "v-square-img",
                                                                              value: {
                                                                                ratio: 1.5
                                                                              },
                                                                              expression:
                                                                                "{ ratio: 1.5 }"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "vertical-center-transform",
                                                                          attrs: {
                                                                            src:
                                                                              task.image +
                                                                              _vm.lowSrcQuery
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "img-overlay"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "img",
                                                                            {
                                                                              staticClass:
                                                                                "img-tick",
                                                                              attrs: {
                                                                                src:
                                                                                  "/img/Create Pickl/selectpickl_icon.png"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "vertical-center-transform task-name"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  task.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tab-pane fade in",
                                                            attrs: {
                                                              role: "tabpanel",
                                                              id:
                                                                "photo-hospitality-" +
                                                                index
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.hospitalityTasks,
                                                            function(task) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: task.id,
                                                                  staticClass:
                                                                    "col-xs-3 col-md-2 photo"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          activity
                                                                            .config
                                                                            .task_ids,
                                                                        expression:
                                                                          "activity.config.task_ids"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      type:
                                                                        "checkbox",
                                                                      id:
                                                                        "photo-task-" +
                                                                        index +
                                                                        "-" +
                                                                        task.id
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        task.id,
                                                                      checked: Array.isArray(
                                                                        activity
                                                                          .config
                                                                          .task_ids
                                                                      )
                                                                        ? _vm._i(
                                                                            activity
                                                                              .config
                                                                              .task_ids,
                                                                            task.id
                                                                          ) > -1
                                                                        : activity
                                                                            .config
                                                                            .task_ids
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            activity
                                                                              .config
                                                                              .task_ids,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c = $$el.checked
                                                                            ? true
                                                                            : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              task.id,
                                                                            $$i = _vm._i(
                                                                              $$a,
                                                                              $$v
                                                                            )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                activity.config,
                                                                                "task_ids",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                activity.config,
                                                                                "task_ids",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            activity.config,
                                                                            "task_ids",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  }),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "img-contain",
                                                                      attrs: {
                                                                        for:
                                                                          "photo-task-" +
                                                                          index +
                                                                          "-" +
                                                                          task.id
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "square-img",
                                                                              rawName:
                                                                                "v-square-img",
                                                                              value: {
                                                                                ratio: 1.5
                                                                              },
                                                                              expression:
                                                                                "{ ratio: 1.5 }"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "vertical-center-transform",
                                                                          attrs: {
                                                                            src:
                                                                              task.image +
                                                                              _vm.lowSrcQuery
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "img-overlay"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "img",
                                                                            {
                                                                              staticClass:
                                                                                "img-tick",
                                                                              attrs: {
                                                                                src:
                                                                                  "/img/Create Pickl/selectpickl_icon.png"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "vertical-center-transform task-name"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  task.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tab-pane fade in",
                                                            attrs: {
                                                              role: "tabpanel",
                                                              id:
                                                                "photo-retail-" +
                                                                index
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.retailTasks,
                                                            function(task) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: task.id,
                                                                  staticClass:
                                                                    "col-xs-3 col-md-2 photo"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          activity
                                                                            .config
                                                                            .task_ids,
                                                                        expression:
                                                                          "activity.config.task_ids"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      type:
                                                                        "checkbox",
                                                                      id:
                                                                        "photo-task-" +
                                                                        index +
                                                                        "-" +
                                                                        task.id
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        task.id,
                                                                      checked: Array.isArray(
                                                                        activity
                                                                          .config
                                                                          .task_ids
                                                                      )
                                                                        ? _vm._i(
                                                                            activity
                                                                              .config
                                                                              .task_ids,
                                                                            task.id
                                                                          ) > -1
                                                                        : activity
                                                                            .config
                                                                            .task_ids
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            activity
                                                                              .config
                                                                              .task_ids,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c = $$el.checked
                                                                            ? true
                                                                            : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              task.id,
                                                                            $$i = _vm._i(
                                                                              $$a,
                                                                              $$v
                                                                            )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                activity.config,
                                                                                "task_ids",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                activity.config,
                                                                                "task_ids",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            activity.config,
                                                                            "task_ids",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  }),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "img-contain",
                                                                      attrs: {
                                                                        for:
                                                                          "photo-task-" +
                                                                          index +
                                                                          "-" +
                                                                          task.id
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "square-img",
                                                                              rawName:
                                                                                "v-square-img",
                                                                              value: {
                                                                                ratio: 1.5
                                                                              },
                                                                              expression:
                                                                                "{ ratio: 1.5 }"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "vertical-center-transform",
                                                                          attrs: {
                                                                            src:
                                                                              task.image +
                                                                              _vm.lowSrcQuery
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "img-overlay"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "img",
                                                                            {
                                                                              staticClass:
                                                                                "img-tick",
                                                                              attrs: {
                                                                                src:
                                                                                  "/img/Create Pickl/selectpickl_icon.png"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "vertical-center-transform task-name"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  task.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      ]
                                                    ),
                                                    _c("div", {
                                                      staticClass: "clearfix"
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        activity.type === "video"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                { staticClass: "row mt15" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-sm-8 col-sm-offset-2"
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticStyle: {
                                                            "text-align":
                                                              "left",
                                                            "font-size": "16px",
                                                            color: "#333",
                                                            "margin-bottom":
                                                              "20px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    User will need to record and upload the video of specified place as you will describe in description\n                  "
                                                          )
                                                        ]
                                                      ),
                                                      _c("textarea", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              activity.config
                                                                .videoDescription,
                                                            expression:
                                                              "activity.config.videoDescription"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "input textarea",
                                                        staticStyle: {
                                                          "min-height": "100px"
                                                        },
                                                        attrs: {
                                                          placeholder:
                                                            "Enter description for the video recording location",
                                                          rows: "4"
                                                        },
                                                        domProps: {
                                                          value:
                                                            activity.config
                                                              .videoDescription
                                                        },
                                                        on: {
                                                          focus: function(
                                                            $event
                                                          ) {
                                                            return _vm.onVideoDescriptionFocus(
                                                              index
                                                            )
                                                          },
                                                          blur: function(
                                                            $event
                                                          ) {
                                                            return _vm.onVideoDescriptionBlur(
                                                              index
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              activity.config,
                                                              "videoDescription",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        activity.type === "selfie"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                { staticClass: "row mt15" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-sm-8 col-sm-offset-2"
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticStyle: {
                                                            "text-align":
                                                              "left",
                                                            "font-size": "16px",
                                                            color: "#333",
                                                            "margin-bottom":
                                                              "20px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    User will need to take a selfie as you will describe below\n                  "
                                                          )
                                                        ]
                                                      ),
                                                      _c("textarea", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              activity.config
                                                                .selfieDescription,
                                                            expression:
                                                              "activity.config.selfieDescription"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "input textarea",
                                                        staticStyle: {
                                                          "min-height": "100px"
                                                        },
                                                        attrs: {
                                                          placeholder:
                                                            "Enter description for the selfie activity",
                                                          rows: "4"
                                                        },
                                                        domProps: {
                                                          value:
                                                            activity.config
                                                              .selfieDescription
                                                        },
                                                        on: {
                                                          focus: function(
                                                            $event
                                                          ) {
                                                            return _vm.onSelfieDescriptionFocus(
                                                              index
                                                            )
                                                          },
                                                          blur: function(
                                                            $event
                                                          ) {
                                                            return _vm.onSelfieDescriptionBlur(
                                                              index
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              activity.config,
                                                              "selfieDescription",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        activity.type === "survey"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                { staticClass: "row mt15" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-sm-8 col-sm-offset-2"
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                activity.config
                                                                  .survey_id,
                                                              expression:
                                                                "activity.config.survey_id"
                                                            }
                                                          ],
                                                          staticClass: "input",
                                                          staticStyle: {
                                                            "font-size": "18px",
                                                            padding:
                                                              "14px 42px 14px 16px"
                                                          },
                                                          attrs: {
                                                            name: "survey_id"
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                activity.config,
                                                                "survey_id",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                disabled: "",
                                                                selected: "",
                                                                value: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Select Survey"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            _vm.surveys,
                                                            function(survey) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  key:
                                                                    survey.id,
                                                                  domProps: {
                                                                    value:
                                                                      survey.id
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      survey.title
                                                                    ) +
                                                                      " - " +
                                                                      _vm._s(
                                                                        survey.type
                                                                      ) +
                                                                      " (" +
                                                                      _vm._s(
                                                                        survey.survey_questions_count
                                                                      ) +
                                                                      " Questions)"
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        activity.type === "buy-me"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                { staticClass: "row mt15" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-sm-8 col-sm-offset-2"
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                activity.config
                                                                  .reimbursementCredits,
                                                              expression:
                                                                "activity.config.reimbursementCredits"
                                                            }
                                                          ],
                                                          staticClass: "input",
                                                          staticStyle: {
                                                            "font-size": "18px",
                                                            padding:
                                                              "14px 42px 14px 16px"
                                                          },
                                                          attrs: {
                                                            name:
                                                              "reimbursement_credits"
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                activity.config,
                                                                "reimbursementCredits",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                disabled: "",
                                                                selected: "",
                                                                value: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Select Reimbursement Credits"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "1"
                                                              }
                                                            },
                                                            [_vm._v("1")]
                                                          ),
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "2"
                                                              }
                                                            },
                                                            [_vm._v("2")]
                                                          ),
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "5"
                                                              }
                                                            },
                                                            [_vm._v("5")]
                                                          ),
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "10"
                                                              }
                                                            },
                                                            [_vm._v("10")]
                                                          ),
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "12"
                                                              }
                                                            },
                                                            [_vm._v("12")]
                                                          ),
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "15"
                                                              }
                                                            },
                                                            [_vm._v("15")]
                                                          ),
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "20"
                                                              }
                                                            },
                                                            [_vm._v("20")]
                                                          ),
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "25"
                                                              }
                                                            },
                                                            [_vm._v("25")]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        activity.type === "deal-drop"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                { staticClass: "row mt15" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-sm-8 col-sm-offset-2"
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                activity.config
                                                                  .couponId,
                                                              expression:
                                                                "activity.config.couponId"
                                                            }
                                                          ],
                                                          staticClass: "input",
                                                          staticStyle: {
                                                            "font-size": "18px",
                                                            padding:
                                                              "14px 42px 14px 16px"
                                                          },
                                                          attrs: {
                                                            name: "coupon_id"
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                activity.config,
                                                                "couponId",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                disabled: "",
                                                                selected: "",
                                                                value: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Select Coupon"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            _vm.brandCoupons,
                                                            function(coupon) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  key:
                                                                    coupon.id,
                                                                  domProps: {
                                                                    value:
                                                                      coupon.id
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      coupon.name
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        activity.type === "watch"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                { staticClass: "row mt15" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-sm-8 col-sm-offset-2"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              activity.config
                                                                .youtubeUrl,
                                                            expression:
                                                              "activity.config.youtubeUrl"
                                                          }
                                                        ],
                                                        staticClass: "input",
                                                        staticStyle: {
                                                          "font-size": "18px",
                                                          padding: "14px 16px",
                                                          "margin-bottom":
                                                            "15px"
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          placeholder:
                                                            "Enter YouTube URL"
                                                        },
                                                        domProps: {
                                                          value:
                                                            activity.config
                                                              .youtubeUrl
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              activity.config,
                                                              "youtubeUrl",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _c("textarea", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              activity.config
                                                                .description,
                                                            expression:
                                                              "activity.config.description"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "input textarea",
                                                        staticStyle: {
                                                          "min-height": "100px"
                                                        },
                                                        attrs: {
                                                          placeholder:
                                                            "Enter description",
                                                          rows: "4"
                                                        },
                                                        domProps: {
                                                          value:
                                                            activity.config
                                                              .description
                                                        },
                                                        on: {
                                                          focus: function(
                                                            $event
                                                          ) {
                                                            return _vm.onWatchDescriptionFocus(
                                                              index
                                                            )
                                                          },
                                                          blur: function(
                                                            $event
                                                          ) {
                                                            return _vm.onWatchDescriptionBlur(
                                                              index
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              activity.config,
                                                              "description",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        activity.type === "url-visit"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                { staticClass: "row mt15" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-sm-8 col-sm-offset-2"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              activity.config
                                                                .url,
                                                            expression:
                                                              "activity.config.url"
                                                          }
                                                        ],
                                                        staticClass: "input",
                                                        staticStyle: {
                                                          "font-size": "18px",
                                                          padding: "14px 16px",
                                                          "margin-bottom":
                                                            "15px"
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          placeholder:
                                                            "Enter URL"
                                                        },
                                                        domProps: {
                                                          value:
                                                            activity.config.url
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              activity.config,
                                                              "url",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _c("textarea", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              activity.config
                                                                .description,
                                                            expression:
                                                              "activity.config.description"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "input textarea",
                                                        staticStyle: {
                                                          "min-height": "100px"
                                                        },
                                                        attrs: {
                                                          placeholder:
                                                            "Enter description",
                                                          rows: "4"
                                                        },
                                                        domProps: {
                                                          value:
                                                            activity.config
                                                              .description
                                                        },
                                                        on: {
                                                          focus: function(
                                                            $event
                                                          ) {
                                                            return _vm.onUrlVisitDescriptionFocus(
                                                              index
                                                            )
                                                          },
                                                          blur: function(
                                                            $event
                                                          ) {
                                                            return _vm.onUrlVisitDescriptionBlur(
                                                              index
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              activity.config,
                                                              "description",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        activity.type === "app-install"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                { staticClass: "row mt15" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-sm-8 col-sm-offset-2"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "mb10" },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "block mb5"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Select link created by company"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex gap10",
                                                              staticStyle: {
                                                                display: "flex",
                                                                gap: "10px",
                                                                "flex-wrap":
                                                                  "wrap",
                                                                "align-items":
                                                                  "center"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "select",
                                                                {
                                                                  staticClass:
                                                                    "input",
                                                                  staticStyle: {
                                                                    flex: "1",
                                                                    "min-width":
                                                                      "200px",
                                                                    "font-size":
                                                                      "16px",
                                                                    padding:
                                                                      "10px 14px"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      activity
                                                                        .config
                                                                        .link_id ||
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onBrandLinkSelectForActivity(
                                                                        index,
                                                                        "app-install",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      attrs: {
                                                                        value:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Choose a link..."
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._l(
                                                                    _vm.getBrandLinksByType(
                                                                      "app-install"
                                                                    ),
                                                                    function(
                                                                      link
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key:
                                                                            "app-" +
                                                                            link.id,
                                                                          domProps: {
                                                                            value:
                                                                              link.id
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              link.title ||
                                                                                link.website_link ||
                                                                                link.id
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn-positive",
                                                                  attrs: {
                                                                    type:
                                                                      "button",
                                                                    "data-toggle":
                                                                      "modal",
                                                                    "data-target":
                                                                      "#create-link-mix-popup"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Create new link"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        activity.type === "review"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                { staticClass: "row mt15" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-sm-8 col-sm-offset-2"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "mb10" },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "block mb5"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Select link created by company"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex gap10",
                                                              staticStyle: {
                                                                display: "flex",
                                                                gap: "10px",
                                                                "flex-wrap":
                                                                  "wrap",
                                                                "align-items":
                                                                  "center"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "select",
                                                                {
                                                                  staticClass:
                                                                    "input",
                                                                  staticStyle: {
                                                                    flex: "1",
                                                                    "min-width":
                                                                      "200px",
                                                                    "font-size":
                                                                      "16px",
                                                                    padding:
                                                                      "10px 14px"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      activity
                                                                        .config
                                                                        .link_id ||
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onBrandLinkSelectForActivity(
                                                                        index,
                                                                        "review",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      attrs: {
                                                                        value:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Choose a link..."
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._l(
                                                                    _vm.getBrandLinksByType(
                                                                      "review"
                                                                    ),
                                                                    function(
                                                                      link
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key:
                                                                            "review-" +
                                                                            link.id,
                                                                          domProps: {
                                                                            value:
                                                                              link.id
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              link.title ||
                                                                                link.website_link ||
                                                                                link.id
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn-positive",
                                                                  attrs: {
                                                                    type:
                                                                      "button",
                                                                    "data-toggle":
                                                                      "modal",
                                                                    "data-target":
                                                                      "#create-link-mix-popup"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Create new link"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm.activityTypes.length < _vm.maxActivities
                          ? _c(
                              "div",
                              { staticClass: "mix-add-activity-block" },
                              [
                                _c(
                                  "p",
                                  { staticClass: "mix-add-activity-label" },
                                  [_vm._v("Add another activity")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mix-add-activity-row" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentActivityType,
                                            expression: "currentActivityType"
                                          }
                                        ],
                                        staticClass:
                                          "input mix-input mix-select-lg",
                                        attrs: { name: "new_activity_type" },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.currentActivityType = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              disabled: "",
                                              selected: "",
                                              value: ""
                                            }
                                          },
                                          [_vm._v("Choose activity type…")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "product" } },
                                          [_vm._v("Specific Pics")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "selfie" } },
                                          [_vm._v("Selfie")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "photo" } },
                                          [_vm._v("General Pics")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "survey" } },
                                          [_vm._v("Survey")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "buy-me" } },
                                          [_vm._v("Reimbursement")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "deal-drop" } },
                                          [
                                            _vm._v(
                                              "Website URL (Giveaway, Coupon)"
                                            )
                                          ]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "watch" } },
                                          [
                                            _vm._v(
                                              "Watch Media (video/short/story)"
                                            )
                                          ]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "app-install" } },
                                          [_vm._v("App Install")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "review" } },
                                          [
                                            _vm._v(
                                              "Online Review (external link)"
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn-lg-green mix-btn-add-activity",
                                        attrs: {
                                          type: "button",
                                          disabled: !_vm.currentActivityType
                                        },
                                        on: { click: _vm.addActivityType }
                                      },
                                      [
                                        _vm._v(
                                          "\n              + Add\n            "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "row mt15 mix-form-actions" },
                          [
                            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-lg-grey mix-btn-secondary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.step = 1
                                    }
                                  }
                                },
                                [_vm._v("Previous")]
                              )
                            ]),
                            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-lg-green mix-btn-primary",
                                  attrs: {
                                    type: "button",
                                    disabled:
                                      _vm.activityTypes.length === 0 ||
                                      !_vm.areAllActivityTypesValid
                                  },
                                  on: { click: _vm.step2 }
                                },
                                [_vm._v("Next: Sort order")]
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.step == 3
                  ? _c(
                      "form",
                      {
                        staticClass: "mix-step-form",
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.step3($event)
                          }
                        }
                      },
                      [
                        _vm._m(4),
                        _vm.activityTypes.length === 0
                          ? _c("div", { staticClass: "mix-empty-state mt15" }, [
                              _c("p", [
                                _vm._v(
                                  "No activities to sort. Go back and add activities first."
                                )
                              ])
                            ])
                          : _c(
                              "div",
                              { staticClass: "mt15 mix-sort-list" },
                              _vm._l(_vm.activityTypes, function(
                                activity,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass:
                                      "sortable-activity-item mix-sort-item",
                                    class: {
                                      dragging: _vm.draggedIndex === index,
                                      "drag-over": _vm.dragOverIndex === index
                                    },
                                    attrs: {
                                      "data-index": index,
                                      draggable: true
                                    },
                                    on: {
                                      dragstart: function($event) {
                                        return _vm.onDragStart(index, $event)
                                      },
                                      dragover: function($event) {
                                        $event.preventDefault()
                                        return _vm.onDragOver($event)
                                      },
                                      drop: function($event) {
                                        return _vm.onDrop(index, $event)
                                      },
                                      dragenter: function($event) {
                                        return _vm.onDragEnter($event)
                                      },
                                      dragleave: function($event) {
                                        return _vm.onDragLeave($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(5, true),
                                      _c("div", { staticClass: "col-xs-11" }, [
                                        _c(
                                          "h3",
                                          {
                                            staticStyle: {
                                              color: "#782b54",
                                              "margin-top": "0",
                                              "margin-bottom": "5px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Activity " +
                                                _vm._s(index + 1) +
                                                ": " +
                                                _vm._s(
                                                  _vm.getActivityTypeLabel(
                                                    activity.type
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "#666",
                                              margin: "0",
                                              "font-size": "14px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getActivityDescription(
                                                    activity
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              }),
                              0
                            ),
                        _c(
                          "div",
                          { staticClass: "row mt15 mix-form-actions" },
                          [
                            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-lg-grey mix-btn-secondary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.step = 2
                                    }
                                  }
                                },
                                [_vm._v("Previous")]
                              )
                            ]),
                            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                              _c("input", {
                                staticClass: "btn-lg-green mix-btn-primary",
                                attrs: {
                                  type: "submit",
                                  value: "Next: Location",
                                  disabled: _vm.activityTypes.length === 0
                                }
                              })
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.step == 4
                  ? _c(
                      "form",
                      {
                        staticClass: "mix-step-form",
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.step4($event)
                          }
                        }
                      },
                      [
                        _vm._m(6),
                        _vm.pickl.geoRestricted === 1
                          ? _c("div", { staticClass: "mt15" }, [
                              _c("div", { staticClass: "filter-row" }, [
                                _c("div", { staticClass: "filter-control" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.pickl.countryId,
                                          expression: "pickl.countryId"
                                        }
                                      ],
                                      staticClass: "btn-select-box",
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.pickl,
                                              "countryId",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          _vm.getStates
                                        ]
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("Select Country")
                                      ]),
                                      _vm._l(_vm.countries, function(country) {
                                        return _c(
                                          "option",
                                          {
                                            key: country.id,
                                            domProps: { value: country.id }
                                          },
                                          [_vm._v(_vm._s(country.name))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]),
                                _c("div", { staticClass: "filter-control" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.stateId,
                                          expression: "stateId"
                                        }
                                      ],
                                      staticClass: "btn-select-box",
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.stateId = $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          _vm.getStoresList
                                        ]
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("Select State")
                                      ]),
                                      _vm._l(_vm.states, function(state) {
                                        return _c(
                                          "option",
                                          {
                                            key: state.id,
                                            domProps: { value: state.id }
                                          },
                                          [_vm._v(_vm._s(state.name))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]),
                                _c("div", { staticClass: "filter-control" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.storeId,
                                          expression: "storeId"
                                        }
                                      ],
                                      staticClass: "btn-select-box",
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.storeId = $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          function($event) {
                                            return _vm.updateStoreHandler(true)
                                          }
                                        ]
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("Select Retailer")
                                      ]),
                                      _vm._l(_vm.retailers, function(retailer) {
                                        return _c(
                                          "option",
                                          {
                                            key: retailer.id,
                                            domProps: { value: retailer.id }
                                          },
                                          [_vm._v(_vm._s(retailer.name))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]),
                                _c("div", { staticClass: "filter-control" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.storeCity,
                                        expression: "storeCity"
                                      }
                                    ],
                                    staticClass:
                                      "btn-select font-14px disabled-gray",
                                    attrs: {
                                      type: "text",
                                      disabled: !_vm.checkIfStateRetailerSelected,
                                      placeholder: "City"
                                    },
                                    domProps: { value: _vm.storeCity },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.storeCity = $event.target.value
                                      }
                                    }
                                  })
                                ]),
                                _c("div", { staticClass: "filter-control" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.storeZipCode,
                                        expression: "storeZipCode"
                                      }
                                    ],
                                    staticClass:
                                      "btn-select font-14px disabled-gray",
                                    attrs: {
                                      type: "text",
                                      disabled: !_vm.checkIfStateRetailerSelected,
                                      placeholder: "Zipcode"
                                    },
                                    domProps: { value: _vm.storeZipCode },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.storeZipCode = $event.target.value
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm.pickl.geoRestricted === 1
                                ? _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-sm-4" }),
                                    _c("div", { staticClass: "col-sm-4" }, [
                                      _c(
                                        "h3",
                                        {
                                          staticStyle: { "text-align": "left" }
                                        },
                                        [_vm._v("Or")]
                                      ),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.selectedLocationCatalogue,
                                              expression:
                                                "selectedLocationCatalogue"
                                            }
                                          ],
                                          staticClass: "btn-select-box",
                                          on: {
                                            change: [
                                              function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.selectedLocationCatalogue = $event
                                                  .target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              },
                                              _vm.getCatalogueStoreLocations
                                            ]
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "0" } },
                                            [_vm._v("Select Store Cluster")]
                                          ),
                                          _vm._l(
                                            _vm.locationCatalogues,
                                            function(catalouge) {
                                              return _c(
                                                "option",
                                                {
                                                  key: catalouge.id,
                                                  domProps: {
                                                    value: catalouge.id
                                                  }
                                                },
                                                [_vm._v(_vm._s(catalouge.name))]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]),
                                    _c("div", { staticClass: "col-sm-4" })
                                  ])
                                : _vm._e(),
                              _vm.duplicatePicklErrorMessage != ""
                                ? _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.duplicatePicklErrorMessage
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm.duplicatePicklLocationIds.length > 0
                                ? _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        display: "block",
                                        "text-align": "right",
                                        "margin-bottom": "10px",
                                        color: "#782B54",
                                        cursor: "pointer",
                                        "text-decoration": "none"
                                      },
                                      on: {
                                        click: _vm.removeDuplicateLocations
                                      }
                                    },
                                    [_vm._v("Remove Duplicate Locations")]
                                  )
                                : _vm._e(),
                              _vm.updatedStores.length > 0 ||
                              _vm.selectedRetails.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "green-border-box mb10 checklist"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-sm-6" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "checklist-head" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.selectAll,
                                                    expression: "selectAll"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id: "all-stores-geo"
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.selectAll
                                                  )
                                                    ? _vm._i(
                                                        _vm.selectAll,
                                                        null
                                                      ) > -1
                                                    : _vm.selectAll
                                                },
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$a = _vm.selectAll,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.selectAll = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.selectAll = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.selectAll = $$c
                                                      }
                                                    },
                                                    _vm.onSelectAll
                                                  ]
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "all-stores-geo"
                                                  }
                                                },
                                                [_vm._v("Select All Retailers")]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "VuePerfectScrollbar",
                                            {
                                              staticClass: "checklist-contain"
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass: "checklist-body"
                                                },
                                                _vm._l(
                                                  _vm.updatedStores,
                                                  function(store) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        key: store.id,
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.setSelected(
                                                              store,
                                                              !store.selected
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "checklist-item"
                                                          },
                                                          [
                                                            _c("img", {
                                                              staticStyle: {
                                                                float: "left",
                                                                "margin-right":
                                                                  "3px",
                                                                "margin-top":
                                                                  "4px"
                                                              },
                                                              attrs: {
                                                                src:
                                                                  store.store
                                                                    .image,
                                                                alt: "Store"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                attrs: {
                                                                  title:
                                                                    store.store
                                                                      .name
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    store.store
                                                                      .name
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "address",
                                                                attrs: {
                                                                  title:
                                                                    store.address
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    store.address
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm.inSelectedStoresList(
                                                              store
                                                            )
                                                              ? _c("img", {
                                                                  attrs: {
                                                                    src:
                                                                      "/img/Create Pickl/storenameSelect_icon.png",
                                                                    alt:
                                                                      "Selected"
                                                                  }
                                                                })
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "col-sm-6" },
                                        [
                                          _vm._m(7),
                                          _c(
                                            "VuePerfectScrollbar",
                                            {
                                              staticClass: "checklist-contain"
                                            },
                                            [
                                              _vm.selectedRetails.length > 0
                                                ? _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "checklist-body"
                                                    },
                                                    _vm._l(
                                                      _vm.selectedRetails,
                                                      function(ss, index) {
                                                        return _c(
                                                          "li",
                                                          { key: ss.id },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "checklist-item"
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticStyle: {
                                                                    float:
                                                                      "left",
                                                                    "margin-right":
                                                                      "3px",
                                                                    "margin-top":
                                                                      "4px"
                                                                  },
                                                                  attrs: {
                                                                    src:
                                                                      ss.image,
                                                                    alt: "Store"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    attrs: {
                                                                      title:
                                                                        ss.name
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ss.name
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "address",
                                                                    attrs: {
                                                                      title:
                                                                        ss.address
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ss.address
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "remove-icon",
                                                                  staticStyle: {
                                                                    width:
                                                                      "24px",
                                                                    height:
                                                                      "24px"
                                                                  },
                                                                  attrs: {
                                                                    src:
                                                                      "/img/Create Pickl/cancel_purple.png",
                                                                    alt:
                                                                      "Remove"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeRetailer(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _c(
                                                    "h2",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "left"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "No Retailer Selected"
                                                      )
                                                    ]
                                                  )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _c("div", { staticClass: "mt15" }, [
                              _c("div", { staticClass: "filter-row" }, [
                                _c("div", { staticClass: "filter-control" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.pickl.countryId,
                                          expression: "pickl.countryId"
                                        }
                                      ],
                                      staticClass: "btn-select-box",
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.pickl,
                                              "countryId",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          _vm.getStates
                                        ]
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("Select Country")
                                      ]),
                                      _vm._l(_vm.countries, function(country) {
                                        return _c(
                                          "option",
                                          {
                                            key: country.id,
                                            domProps: { value: country.id }
                                          },
                                          [_vm._v(_vm._s(country.name))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]),
                                _c("div", { staticClass: "filter-control" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.pickl.launchArea,
                                          expression: "pickl.launchArea"
                                        }
                                      ],
                                      staticClass: "btn-select-box",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.pickl,
                                            "launchArea",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("Select Launch Area")
                                      ]),
                                      _c(
                                        "option",
                                        { attrs: { value: "states" } },
                                        [_vm._v("States")]
                                      )
                                    ]
                                  )
                                ]),
                                _vm.pickl.launchArea == "cities"
                                  ? _c(
                                      "div",
                                      { staticClass: "filter-control" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.stateId,
                                                expression: "stateId"
                                              }
                                            ],
                                            staticClass: "btn-select-box",
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.stateId = $event.target
                                                    .multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                },
                                                _vm.getStateCities
                                              ]
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              { attrs: { value: "" } },
                                              [_vm._v("Select State")]
                                            ),
                                            _vm._l(_vm.states, function(state) {
                                              return _c(
                                                "option",
                                                {
                                                  key: state.id,
                                                  domProps: { value: state.id }
                                                },
                                                [_vm._v(_vm._s(state.name))]
                                              )
                                            })
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c("div", { staticClass: "filter-control" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.pickl.selectedRetailerId,
                                          expression: "pickl.selectedRetailerId"
                                        }
                                      ],
                                      staticClass: "btn-select-box",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.pickl,
                                            "selectedRetailerId",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("Select Retailer")
                                      ]),
                                      _vm._l(_vm.allRetailers, function(
                                        retailer
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: retailer.id,
                                            domProps: { value: retailer.id }
                                          },
                                          [_vm._v(_vm._s(retailer.name))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]),
                                _c("div", { staticClass: "filter-control" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.pickl.maxTasksPerUser,
                                          expression: "pickl.maxTasksPerUser"
                                        }
                                      ],
                                      staticClass: "btn-select-box",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.pickl,
                                            "maxTasksPerUser",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("Single User Limit")
                                      ]),
                                      _c("option", { attrs: { value: "1" } }, [
                                        _vm._v("1")
                                      ]),
                                      _c("option", { attrs: { value: "2" } }, [
                                        _vm._v("2")
                                      ]),
                                      _c("option", { attrs: { value: "3" } }, [
                                        _vm._v("3")
                                      ]),
                                      _c("option", { attrs: { value: "4" } }, [
                                        _vm._v("4")
                                      ]),
                                      _c("option", { attrs: { value: "5" } }, [
                                        _vm._v("5")
                                      ])
                                    ]
                                  )
                                ]),
                                _c("div", { staticClass: "filter-control" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.pickl.responseCounter,
                                          expression: "pickl.responseCounter"
                                        }
                                      ],
                                      staticClass: "btn-select-box",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.pickl,
                                            "responseCounter",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("Total Activity count")
                                      ]),
                                      _vm._l(_vm.counterDropDownList, function(
                                        number
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: number,
                                            domProps: { value: number }
                                          },
                                          [_vm._v(_vm._s(number))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]),
                                _c("div", { staticClass: "filter-control" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.pickl.credits,
                                        expression: "pickl.credits"
                                      }
                                    ],
                                    staticClass: "btn-select font-14px",
                                    attrs: {
                                      type: "text",
                                      placeholder: "$5 Incentives"
                                    },
                                    domProps: { value: _vm.pickl.credits },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.pickl,
                                          "credits",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm.pickl.launchArea == "cities"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "green-border-box mb10 checklist"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-sm-6" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "checklist-head" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.citiesSelectAll,
                                                    expression:
                                                      "citiesSelectAll"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id: "all-cities-non-geo"
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.citiesSelectAll
                                                  )
                                                    ? _vm._i(
                                                        _vm.citiesSelectAll,
                                                        null
                                                      ) > -1
                                                    : _vm.citiesSelectAll
                                                },
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$a =
                                                          _vm.citiesSelectAll,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.citiesSelectAll = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.citiesSelectAll = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.citiesSelectAll = $$c
                                                      }
                                                    },
                                                    _vm.onSelectAllCities
                                                  ]
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "all-cities-non-geo"
                                                  }
                                                },
                                                [_vm._v("Select Cities")]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "VuePerfectScrollbar",
                                            {
                                              staticClass: "checklist-contain"
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass: "checklist-body"
                                                },
                                                _vm._l(_vm.cities, function(
                                                  city
                                                ) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: city.id,
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.setCitySelected(
                                                            city,
                                                            !city.selected
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checklist-item"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                title: city.name
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  city.name
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm.inSelectedCitiesList(
                                                            city
                                                          )
                                                            ? _c("img", {
                                                                attrs: {
                                                                  src:
                                                                    "/img/Create Pickl/storenameSelect_icon.png",
                                                                  alt:
                                                                    "Selected"
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }),
                                                0
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "col-sm-6" },
                                        [
                                          _vm._m(8),
                                          _c(
                                            "VuePerfectScrollbar",
                                            {
                                              staticClass: "checklist-contain"
                                            },
                                            [
                                              _vm.selectedCities.length > 0
                                                ? _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "checklist-body"
                                                    },
                                                    _vm._l(
                                                      _vm.selectedCities,
                                                      function(sc, index) {
                                                        return _c(
                                                          "li",
                                                          { key: sc.id },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "checklist-item"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    attrs: {
                                                                      title:
                                                                        sc.name
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        sc.name
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "remove-icon",
                                                                  staticStyle: {
                                                                    width:
                                                                      "24px",
                                                                    height:
                                                                      "24px"
                                                                  },
                                                                  attrs: {
                                                                    src:
                                                                      "/img/Create Pickl/cancel_purple.png",
                                                                    alt:
                                                                      "Remove"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeCity(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _c(
                                                    "h3",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "left"
                                                      }
                                                    },
                                                    [_vm._v("No City Selected")]
                                                  )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.pickl.launchArea == "states"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "green-border-box mb10 checklist"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-sm-6" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "checklist-head" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.selectAll,
                                                    expression: "selectAll"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id: "all-stores-non-geo"
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.selectAll
                                                  )
                                                    ? _vm._i(
                                                        _vm.selectAll,
                                                        null
                                                      ) > -1
                                                    : _vm.selectAll
                                                },
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$a = _vm.selectAll,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.selectAll = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.selectAll = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.selectAll = $$c
                                                      }
                                                    },
                                                    _vm.onSelectAllState
                                                  ]
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "all-stores-non-geo"
                                                  }
                                                },
                                                [_vm._v("Select States")]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "VuePerfectScrollbar",
                                            {
                                              staticClass: "checklist-contain"
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass: "checklist-body"
                                                },
                                                _vm._l(_vm.states, function(
                                                  state
                                                ) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: state.id,
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.setStateSelected(
                                                            state,
                                                            !state.selected
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checklist-item"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                title:
                                                                  state.name
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  state.name
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm.inSelectedStatesList(
                                                            state
                                                          )
                                                            ? _c("img", {
                                                                attrs: {
                                                                  src:
                                                                    "/img/Create Pickl/storenameSelect_icon.png",
                                                                  alt:
                                                                    "Selected"
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }),
                                                0
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "col-sm-6" },
                                        [
                                          _vm._m(9),
                                          _c(
                                            "VuePerfectScrollbar",
                                            {
                                              staticClass: "checklist-contain"
                                            },
                                            [
                                              _vm.selectedStates.length > 0
                                                ? _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "checklist-body"
                                                    },
                                                    _vm._l(
                                                      _vm.selectedStates,
                                                      function(ss, index) {
                                                        return _c(
                                                          "li",
                                                          { key: ss.id },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "checklist-item"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    attrs: {
                                                                      title:
                                                                        ss.name
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ss.name
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "remove-icon",
                                                                  staticStyle: {
                                                                    width:
                                                                      "24px",
                                                                    height:
                                                                      "24px"
                                                                  },
                                                                  attrs: {
                                                                    src:
                                                                      "/img/Create Pickl/cancel_purple.png",
                                                                    alt:
                                                                      "Remove"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeState(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _c(
                                                    "h3",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "left"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "No States Selected"
                                                      )
                                                    ]
                                                  )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                        _c(
                          "div",
                          { staticClass: "row mt15 mix-form-actions" },
                          [
                            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-lg-grey mix-btn-secondary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.step = 3
                                    }
                                  }
                                },
                                [_vm._v("Previous")]
                              )
                            ]),
                            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                              _c("input", {
                                staticClass: "btn-lg-green mix-btn-primary",
                                attrs: {
                                  type: "submit",
                                  value: "Create mix campaign",
                                  disabled: !_vm.isLocationSelectionValid
                                }
                              })
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.step == 5 && _vm.launchedCampaignSummary
                  ? _c(
                      "div",
                      { staticClass: "mix-step-form campaign-summary" },
                      [
                        _c("div", { staticClass: "summary-success-header" }, [
                          _c("span", {
                            staticClass:
                              "summary-check-icon glyphicon glyphicon-ok-circle"
                          }),
                          _c("h2", { staticClass: "summary-title" }, [
                            _vm._v("workflow Launched Successfully!")
                          ]),
                          _c("p", { staticClass: "summary-subtitle" }, [
                            _vm._v("Your workflow "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.launchedCampaignSummary.campaignName)
                              )
                            ]),
                            _vm._v(" is now live.")
                          ])
                        ]),
                        _c("div", { staticClass: "summary-card" }, [
                          _c("h3", { staticClass: "summary-card-title" }, [
                            _vm._v("Workflow Details")
                          ]),
                          _c("div", { staticClass: "summary-row" }, [
                            _c("span", { staticClass: "summary-label" }, [
                              _vm._v("Workflow Name")
                            ]),
                            _c("span", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(_vm.launchedCampaignSummary.campaignName)
                              )
                            ])
                          ]),
                          _vm.launchedCampaignSummary.unlockCode
                            ? _c("div", { staticClass: "summary-row" }, [
                                _c("span", { staticClass: "summary-label" }, [
                                  _vm._v("Unlock Code")
                                ]),
                                _c("span", { staticClass: "summary-value" }, [
                                  _c("code", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.launchedCampaignSummary.unlockCode
                                      )
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "summary-row" }, [
                            _c("span", { staticClass: "summary-label" }, [
                              _vm._v("Launch")
                            ]),
                            _c("span", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.launchedCampaignSummary.immediate_start
                                    ? "Immediately"
                                    : _vm.launchedCampaignSummary
                                        .start_date_time
                                )
                              )
                            ])
                          ]),
                          _vm.launchedCampaignSummary.description
                            ? _c("div", { staticClass: "summary-row" }, [
                                _c("span", { staticClass: "summary-label" }, [
                                  _vm._v("Notes")
                                ]),
                                _c("span", { staticClass: "summary-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.launchedCampaignSummary.description
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm.launchedCampaignSummary.autoExtend
                            ? _c("div", { staticClass: "summary-row" }, [
                                _c("span", { staticClass: "summary-label" }, [
                                  _vm._v("Auto Extend")
                                ]),
                                _c("span", { staticClass: "summary-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.launchedCampaignSummary.extendCounter
                                    ) +
                                      " time(s), " +
                                      _vm._s(
                                        _vm.launchedCampaignSummary.extendDays
                                      ) +
                                      " day(s) each"
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]),
                        _c(
                          "div",
                          { staticClass: "summary-card" },
                          [
                            _c("h3", { staticClass: "summary-card-title" }, [
                              _vm._v(
                                "Activities (" +
                                  _vm._s(
                                    _vm.launchedCampaignSummary.activities
                                      .length
                                  ) +
                                  ")"
                              )
                            ]),
                            _vm._l(
                              _vm.launchedCampaignSummary.activities,
                              function(activity, index) {
                                return _c(
                                  "div",
                                  {
                                    key: "summary-activity-" + index,
                                    staticClass: "summary-activity"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "summary-activity-number"
                                      },
                                      [_vm._v(_vm._s(index + 1))]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "summary-activity-label" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getActivityTypeLabel(
                                              activity.type
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }
                            )
                          ],
                          2
                        ),
                        _c("div", { staticClass: "summary-card" }, [
                          _c("h3", { staticClass: "summary-card-title" }, [
                            _vm._v("Location")
                          ]),
                          _vm.launchedCampaignSummary.geoRestricted
                            ? _c("div", { staticClass: "summary-row" }, [
                                _c("span", { staticClass: "summary-label" }, [
                                  _vm._v("Type")
                                ]),
                                _c("span", { staticClass: "summary-value" }, [
                                  _vm._v("Geo-Restricted (Store Specific)")
                                ])
                              ])
                            : _vm._e(),
                          _vm.launchedCampaignSummary.geoRestricted
                            ? _c("div", { staticClass: "summary-row" }, [
                                _c("span", { staticClass: "summary-label" }, [
                                  _vm._v("Stores")
                                ]),
                                _c("span", { staticClass: "summary-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.launchedCampaignSummary.locationCount
                                    ) + " store(s) selected"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          !_vm.launchedCampaignSummary.geoRestricted
                            ? _c("div", { staticClass: "summary-row" }, [
                                _c("span", { staticClass: "summary-label" }, [
                                  _vm._v("Type")
                                ]),
                                _c("span", { staticClass: "summary-value" }, [
                                  _vm._v("Go-Anywhere")
                                ])
                              ])
                            : _vm._e(),
                          !_vm.launchedCampaignSummary.geoRestricted &&
                          _vm.launchedCampaignSummary.locationNames
                            ? _c("div", { staticClass: "summary-row" }, [
                                _c("span", { staticClass: "summary-label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.launchedCampaignSummary.launchArea ===
                                        "cities"
                                        ? "Cities"
                                        : "States"
                                    )
                                  )
                                ]),
                                _c("span", { staticClass: "summary-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.launchedCampaignSummary.locationNames
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          !_vm.launchedCampaignSummary.geoRestricted &&
                          _vm.launchedCampaignSummary.responseCounter
                            ? _c("div", { staticClass: "summary-row" }, [
                                _c("span", { staticClass: "summary-label" }, [
                                  _vm._v("Total Activity Count")
                                ]),
                                _c("span", { staticClass: "summary-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.launchedCampaignSummary
                                        .responseCounter
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          !_vm.launchedCampaignSummary.geoRestricted &&
                          _vm.launchedCampaignSummary.credits
                            ? _c("div", { staticClass: "summary-row" }, [
                                _c("span", { staticClass: "summary-label" }, [
                                  _vm._v("Incentive")
                                ]),
                                _c("span", { staticClass: "summary-value" }, [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        _vm.launchedCampaignSummary.credits
                                      )
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]),
                        _c(
                          "div",
                          { staticClass: "row mt15 mix-form-actions" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col-xs-12",
                                staticStyle: { "text-align": "center" }
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-lg-green mix-btn-primary",
                                    attrs: { type: "button" },
                                    on: { click: _vm.goToPicklsListing }
                                  },
                                  [
                                    _vm._v(
                                      "\n              View Launched Pickls\n            "
                                    )
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn-lg-grey mix-btn-secondary",
                                    staticStyle: { "margin-left": "10px" },
                                    attrs: { type: "button" },
                                    on: { click: _vm.closeSummaryAndReset }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Create Another Workflow\n            "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _c("MediaPopup", {
                  attrs: {
                    popupId: "create-media-popup",
                    brandId: _vm.brandId,
                    editMediaFlag: false
                  },
                  on: {
                    added: _vm.refreshMediaList,
                    updated: _vm.refreshMediaList
                  }
                }),
                _c("CreateLinkPopup", {
                  attrs: {
                    popupId: "create-link-mix-popup",
                    brandId: _vm.brandId
                  },
                  on: { created: _vm.onLinkCreatedFromMix }
                })
              ],
              1
            )
          : _vm._e(),
        !_vm.OnBoarded & !_vm.LoadingBrand
          ? _c("div", { staticClass: "modal-body" }, [
              _c("h3", [
                _vm._v(
                  "You made it! We will contact you soon to activate your credits."
                )
              ]),
              _c(
                "div",
                [
                  _c("router-link", {
                    attrs: {
                      "data-dismiss": "modal",
                      to: "/brand/subscription"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.LoadingBrand
          ? _c("div", [
              _c("h3", [
                _vm._v("Please hold we're gathering your awesome data.")
              ])
            ])
          : _vm._e(),
        !_vm.geoPicklFeature && !_vm.LoadingBrand
          ? _c("div", [
              _c("h3", [
                _vm._v(
                  "This feature is not available for you. Contact support!"
                )
              ])
            ])
          : _vm._e(),
        !(_vm.$store.state.brandCreditsRemaining > 0) &&
        !_vm.loadingCredits &&
        _vm.OnBoarded
          ? _c("div", { staticClass: "modal-body" }, [
              _c("h3", [_vm._v("You don't have any pickls left!")]),
              _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        "data-dismiss": "modal",
                        to: "/brand/subscription"
                      }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn-lg-green wauto",
                          attrs: { type: "button" }
                        },
                        [_vm._v("GET MORE PICKLS")]
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h1", { staticClass: "mix-campaign-title" }, [
        _vm._v("Create Workflow")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mix-label", attrs: { for: "mix-unlock-code" } },
      [
        _vm._v("Unlock Code "),
        _c("span", { staticClass: "mix-label-optional" }, [
          _vm._v("(optional)")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
      _c("span", { staticClass: "mix-label" }, [
        _vm._v("Launch Date & Time (PST)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt15 mix-form-actions" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("input", {
          staticClass: "btn-lg-green mix-btn-primary",
          attrs: { type: "submit", value: "Next: Select activities" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mix-step-intro" }, [
      _c("h2", { staticClass: "mix-step-heading" }, [
        _vm._v("Sort activities")
      ]),
      _c("p", { staticClass: "mix-step-desc" }, [
        _vm._v(
          "Drag and drop to set the order consumers will see. The first activity appears at the top."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-xs-1",
        staticStyle: { "text-align": "left", "padding-top": "5px" }
      },
      [
        _c("span", {
          staticClass: "glyphicon glyphicon-menu-hamburger",
          staticStyle: { color: "#782b54", "font-size": "18px" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mix-step-intro" }, [
      _c("h2", { staticClass: "mix-step-heading" }, [
        _vm._v("Select location")
      ]),
      _c("p", { staticClass: "mix-step-desc" }, [
        _vm._v(
          "Choose where to launch your mix campaign. You can restrict to specific stores or allow broader areas."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checklist-head" }, [
      _c(
        "label",
        { staticStyle: { display: "block" }, attrs: { for: "all-stores-geo" } },
        [_vm._v("Ready To Blast")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checklist-head" }, [
      _c(
        "label",
        {
          staticStyle: { display: "block" },
          attrs: { for: "all-cities-non-geo" }
        },
        [_vm._v("Cities Ready To Blast")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checklist-head" }, [
      _c(
        "label",
        {
          staticStyle: { display: "block" },
          attrs: { for: "all-stores-non-geo" }
        },
        [_vm._v("States Ready To Blast")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }